import styled from 'styled-components'

import mediaQueries from 'components/media-queries'

export const TabBar = styled.ul.attrs(props => ({
  className: props.e2eClass,
  role: 'tablist'
}))`
  display: flex;
  list-style-type: none;
  width: ${({ width }) => width || '35%'};
  font-size: 18px;
  padding: ${({ padding }) => padding || '30px 0px'};
  ${({ scrollable }) =>
    scrollable &&
    `
  overflow-y: hidden;
  overflow-x: auto;
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
   scrollbar-width: none;  /* Firefox */
  `};

  ${mediaQueries.tablet`
    width: ${({ width }) => width || '100%'};
    padding: 20px 0;
  `};
  ${mediaQueries.mobile`
    margin: 0 auto;
    text-align: center;
    width: 100%};
`}

  li {
    ${({ width }) => (!width ? 'width: 100%' : 'initial')}
  }
`

export const Tab = styled.button.attrs(props => ({
  className: props.e2eClass,
  type: 'button',
  role: 'tab'
}))`
  display: flex;
  flex: 1;
  cursor: pointer;
  border: none;
  width: 100%;
  justify-content: center;
  padding-bottom: 12px;

  ${({ selected, theme }) =>
    selected
      ? `border-bottom: 2px solid ${theme.colors.blue};
      color: ${theme.colors.blue};
      font-family: ${theme.fonts.semiBold};`
      : `font-family: ${theme.fonts.regular};
      color: ${theme.colors.doveGray};
    `};

  ${mediaQueries.tablet`
    flex: 0.7;
    text-align: center;
    padding: 7px 30px;
  `};
`

export const TabPanel = styled.div`
  width: 100%;
  display: ${props => (props.active ? 'flex' : 'none')};
  flex-direction: column;
`
